// extracted by mini-css-extract-plugin
export default {"column":"FormColumnLayout_column__6bDDN","optional":"FormColumnLayout_optional__htPcw"};